<template>
    <div class="no-scroll-content" :style="cssProps">
        <action-bar v-if="showActionBar" class="action-bar">
            <template v-slot:left>
                <slot name="actionLeft"></slot>
            </template>
            <template v-slot:right>
                <slot name="actionRight"></slot>
            </template>
        </action-bar>

        <vx-scroll-area :class="{ actionbar: showActionBar }" ref="scrollArea">
            <div class="md:px-8 md:pb-8 pt-4 px-6 pb-6">
                <slot></slot>
            </div>
        </vx-scroll-area>
    </div>
</template>

<script>
import ActionBar from './ActionBar.vue'

export default {
    name: 'crm-content',
    components: {
        ActionBar
    },
    props: {
        displayOrder: [String, Number],
        default: 1
    },
    data() {
        return {}
    },
    computed: {
        showActionBar() {
            return !!(this.$slots.actionLeft || this.$slots.actionRight)
        },
        cssProps() {
            return {
                '--scroll-height': this.displayOrder * 65 + 'px'
            }
        }
    },
    methods: {
        scrollToTop() {
            if (this.$refs.scrollArea) {
                this.$refs.scrollArea.scrollToTop()
            }
        }
    }
}
</script>

<style scoped>
/* .flex-area {
        margin-top: 10px;
        display: flex;
        justify-content: center;
    } */
.action-bar {
    height: 52px;
    width: 100%;
    /* border: 1px solid #fff !important;
        background-color: #fff;
        border-radius: 8px; */
}
.vx-scroll-area.actionbar {
    height: calc(100% - 100px) !important;
}
/*
This needs to be updated to take a dynamic value
Eg:
DisplayOrder = 1 --> 65px (default height of the row with back icon)
DisplayOrder = 2 -->  130px (2 headers) (var(--displayOrder) *
*/
.vx-scroll-area {
    height: calc(100% - var(--scroll-height)) !important;
}
</style>
